// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__9inoL","question":"Question_question__1isyo","description":"Question_description__24BvD"};